const withTestId = (locator: string) => `[data-testid="${locator}"]`;

export default withTestId;
